import React, { FC, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { COMPLETED_PROFILE_PAGE } from "../../navigation/Constants";
import StepperHeader from "./StepperHeader";

export type SteeperPageProps = {
  components: any;
  handleBackBrowserButton: boolean;
  hasBackButton: boolean;
  onClose: () => void;
  containStepperHeader: boolean;
  isFromNeedToVerifyProfile?: boolean;
};

const StepperPage: FC<SteeperPageProps> = ({
  containStepperHeader,
  hasBackButton,
  components,
  handleBackBrowserButton,
  onClose,
  isFromNeedToVerifyProfile,
}) => {
  const history = useHistory();
  const location = useLocation();
  const [activeStep, setActiveStep] = React.useState(0);
  const tab = components[activeStep];

  useEffect(() => {
    if (handleBackBrowserButton) {
      const { state = { activeStep: 0 } }: any = location;
      setActiveStep(state.activeStep);
    }
  }, [location]);

  const hasNext = () => {
    return activeStep + 1 < components.length;
  };

  const handleNext = () => {
    if (tab.isLast) {
      history.push(COMPLETED_PROFILE_PAGE);
      return;
    } else if (handleBackBrowserButton) {
      history.push({
        ...location,
        state: {
          activeStep: activeStep + 1,
        },
      });
    } else setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (handleBackBrowserButton) {
      history.push({
        ...location,
        state: {
          activeStep: activeStep - 1,
        },
      });
    } else setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  console.log({ tab });

  return (
    <div>
      {containStepperHeader && (
        <StepperHeader
          hasBackButton={hasBackButton}
          totalStep={components.length}
          currentStep={activeStep + 1}
          handleNext={handleNext}
          handleBack={handleBack}
          onClose={onClose}
          isFromNeedToVerifyProfile={isFromNeedToVerifyProfile}
        />
      )}
      {tab && (
        <tab.component
          {...tab.props}
          question={tab.question}
          next={handleNext}
          back={handleBack}
          hasNext={hasNext}
        />
      )}
    </div>
  );
};

export default StepperPage;
